import { format } from "timeago.js";

declare var pm: PmInterface;

export default function setupNotification() {
	const { findHtmlEl, findHtmlEls, getClosest } = pm.utils.dom;

	let isOpen = false;
	let isRequesting = false;

	const menuItem = findHtmlEl(".notif-menu-item");
	if (!menuItem) return;

	const menuLink = findHtmlEl(menuItem, ".notif-icon-link");
	const newNotifIndicator = findHtmlEl(menuItem, ".new-notif-indicator");
	const newNotifNumber = newNotifIndicator
		? findHtmlEl(newNotifIndicator, ".new-notif-number")
		: null;
	const dropdown = findHtmlEl(".notif-menu-item .notif-dropdown");

	const allList = dropdown ? findHtmlEls(dropdown, ".notif-item") : [];
	const unreadList = dropdown
		? findHtmlEls(dropdown, ".notif-item.is-unread")
		: [];
	let hasUnread = unreadList.length ? true : false;

	let waitToRemoveReadIndicator = false;

	function init() {
		menuLink?.addEventListener("click", toggleDropdown);
		newNotifIndicator?.addEventListener("click", toggleDropdown);

		jQuery(document).on("click", function (e) {
			if (jQuery(e.target).closest(".notif-menu-item").length === 0) {
				closeDropdown();
			}
		});

		dropdown?.addEventListener("click", function (e) {
			const target = e.target;
			if (!(target instanceof Element)) return;

			if (target instanceof HTMLAnchorElement) {
				return;
			}

			const link = getClosest(target, ".notif-link", 10);
			if (link) return;

			const li = getClosest(target, ".notif-item");
			if (!li) return;

			window.location.href = li.dataset.notifUrl ?? "";
		});
	}

	function toggleDropdown(e: Event) {
		e.preventDefault();

		if (isOpen) {
			closeDropdown();
			return;
		}

		openDropdown();
	}

	function openDropdown() {
		isOpen = true;

		formatTimes();
		dropdown?.classList.add("is-open");
		readNotif();
	}

	function closeDropdown() {
		dropdown?.classList.remove("is-open");

		if (waitToRemoveReadIndicator) {
			unreadList.forEach(function (unreadItem) {
				unreadItem.classList.remove("is-unread");
			});

			newNotifIndicator?.classList.add("is-hidden");
			if (newNotifNumber) newNotifNumber.innerHTML = "0";
			waitToRemoveReadIndicator = false;
		}

		isOpen = false;
	}

	function formatTimes() {
		allList.forEach(function (item) {
			const timeDiv = findHtmlEl(item, ".notif-time");
			if (!timeDiv) return;

			timeDiv.innerHTML = format(timeDiv.dataset.notifTime + " UTC");
		});
	}

	function readNotif() {
		if (!hasUnread) return;

		if (isRequesting) return;
		isRequesting = true;

		const notifIds: number[] = [];

		unreadList.forEach(function (unreadItem) {
			if (!unreadItem.dataset.notifId) return;
			const notifId = parseInt(unreadItem.dataset.notifId, 10);
			notifIds.push(notifId);
		});

		const data = {
			nonce: pm.nonces.readNotif,
			action: "pm_read_notif",
			notif_ids: notifIds,
		};

		jQuery
			.ajax({
				url: pm.ajaxurl,
				type: "post",
				data: data,
			})
			.done(function (r) {
				if (!r || !r.success) return;

				hasUnread = false;
				waitToRemoveReadIndicator = true;
			})
			.always(function (jqXHR) {
				isRequesting = true;
			});
	}

	init();
}
